import {
  Grid,
  Box,
  TextField,
  Typography,
  IconButton,
  makeStyles,
  Tooltip,
} from "@material-ui/core";
import React, { useState, useEffect, useContext } from "react";
import AddIcon from "@material-ui/icons/Add";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import MinimizeIcon from "@material-ui/icons/Minimize";
import { intl } from "../intl";
import { CallMadeOutlined } from "@material-ui/icons";
import {
  editMeeting,
  fetchMeeting,
} from "../actions/Management/meetingManagementAction";
import { setOfficialReportOpen } from "../actions/Management/meetingManagementAction";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import GuardianDownloadIcon from "./Management/Messaging/icons/GuardianDownload";
import RoomContext from "../context/RoomContext";
import { setOfficialReportOpenGlobal } from "../actions/roomActions";

const useStyles = makeStyles({
  textField: {
    border: "1px solid black",
    borderRadius: 0,
    paddingLeft: 5,
    marginTop: 0,
    backgroundColor: "transparent",
    height: "auto",
  },
  mainTitle: {
    textAlign: "center",
    fontSize: "large",
    fontWeight: "bolder",
    border: "1px solid",
    background: "#9e9d9d",
    padding: 5,
  },
  sideTitle: {
    border: "1px solid",
    background: "#d3d3d3",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  button: {
    padding: 5,
    border: "1px solid",
    margin: 6,
    borderRadius: 10,
  },
});

const ConferenceOfficialReport = ({
  room,
  edit = true,
  isDownload,
  onDownloadButtonClick,
  isDownloading = false,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { roomClient } = useContext(RoomContext);
  const me = useSelector((state) => state.user.me);
  const guest = useSelector((state) => state.me);
  const selectedMeeting = useSelector(
    (state) => state.meetingManagement.selectedMeeting
  );
  const isOpenOfficialReport = useSelector(
    (state) => state.meetingManagement.isOpenOfficialReport
  );

  if (guest && guest.id.length === 8) edit = false;
  if (me?.id !== selectedMeeting?.creator?.id) edit = false;

  let roomId;
  if (room.id) roomId = room.id;
  else {
    let arr = window.location.href.split("/");
    roomId = arr[arr.length - 1];
  }

  const [subject, setSubject] = useState(
    selectedMeeting?.officialReport?.subject
      ? selectedMeeting?.officialReport?.subject
      : ""
  );
  const [topics, setTopics] = useState(
    selectedMeeting?.officialReport?.topics
      ? selectedMeeting?.officialReport?.topics
      : []
  );
  const [todos, setTodos] = useState(
    selectedMeeting?.officialReport?.todos
      ? selectedMeeting?.officialReport?.todos
      : []
  );
  const [desicions, setDesicions] = useState(
    selectedMeeting?.officialReport?.desicions
      ? selectedMeeting?.officialReport?.desicions
      : []
  );
  const [participants, setParticipants] = useState(
    selectedMeeting?.officialReport?.participants
      ? selectedMeeting?.officialReport?.participants
      : [{}]
  );

  useEffect(() => {
    if (selectedMeeting) {
      setSubject(
        selectedMeeting?.officialReport?.subject
          ? selectedMeeting?.officialReport?.subject
          : ""
      );
      setTopics(
        selectedMeeting?.officialReport?.topics
          ? selectedMeeting?.officialReport?.topics
          : []
      );
      setTodos(
        selectedMeeting?.officialReport?.todos
          ? selectedMeeting?.officialReport?.todos
          : []
      );
      setDesicions(
        selectedMeeting?.officialReport?.desicions
          ? selectedMeeting?.officialReport?.desicions
          : []
      );
      setParticipants(
        selectedMeeting?.officialReport?.participants
          ? selectedMeeting?.officialReport?.participants
          : [{}]
      );
    }
  }, [selectedMeeting]);

  useEffect(() => {
    if (me?.id.length > 8) getMeeting();
  }, []);

  useEffect(() => {
    if (isOpenOfficialReport === true && me?.id.length > 8) getMeeting();
  }, [isOpenOfficialReport]);

  const getMeeting = () => {
    dispatch(fetchMeeting(roomId));
  };

  const handleAddTopic = () => {
    if (
      topics?.length > 0 &&
      topics[0] !== "" &&
      topics[1] !== "" &&
      topics[2] !== ""
    ) {
      topics.push("");
      setTopics([...topics]);
    }
  };

  const handleAddTodo = () => {
    if (
      todos?.length > 0 &&
      todos[0].todo !== "" &&
      todos[1].todo !== "" &&
      todos[2].todo !== ""
    ) {
      todos.push({});
      setTodos([...todos]);
    }
  };

  const handleAddDesicion = () => {
    if (
      desicions?.length > 0 &&
      desicions[0] !== "" &&
      desicions[1] !== "" &&
      desicions[2] !== ""
    ) {
      desicions.push("");
      setDesicions([...desicions]);
    }
  };

  const handleAddParticipants = () => {
    participants.push({});
    setParticipants([...participants]);
  };

  const handleSaveOfficialReport = () => {
    if (me?.id !== selectedMeeting?.creator?.id) return;
    let body = {
      id: roomId,
      officialReport: {
        dateTime: room.startTime ? room.startTime : room.startDate,
        subject: subject,
        topics: topics,
        todos: todos,
        desicions: desicions,
        participants: participants,
      },
    };
    dispatch(editMeeting(body));
    roomClient.sendMeetingDetails(body);
  };

  return (
    <div style={{ backgroundColor: "white" }}>
      {!isOpenOfficialReport ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "rgb(223 234 255)",
            borderRadius: 5,
            height: 30,
            cursor: "pointer",
            overflow: "hidden",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <IconButton>
              {intl.formatMessage({
                id: "conference.meetingReport",
                defaultMessage: "Meeting Report",
              })}
            </IconButton>
          </div>
          <CallMadeOutlined
            onClick={(e) => {
              e.stopPropagation();
              dispatch(setOfficialReportOpen(true));
            }}
            style={{
              cursor: "pointer",
              marginBottom: 5,
              height: 15,
              width: 15,
            }}
          />
        </div>
      ) : (
        <Box style={{ padding: 20 }} sx={{ flexGrow: 1 }}>
          <Grid
            style={{ justifyContent: "space-between", marginBottom: 10 }}
            container
          >
            {edit === true && (
              <Grid>
                {me?.id === selectedMeeting?.creator?.id && me?.id.length > 8 && (
                  <Tooltip
                    title={intl.formatMessage({
                      id: "conference.downloadReport",
                      defaultMessage: "Download",
                    })}
                  >
                    <IconButton onClick={onDownloadButtonClick}>
                      <GuardianDownloadIcon style={{ color: "#2540E4" }} />
                    </IconButton>
                  </Tooltip>
                )}
                {me?.id === selectedMeeting?.creator?.id && me?.id.length > 8 && (
                  <Tooltip
                    title={intl.formatMessage({
                      id: "conference.save",
                      defaultMessage: "Save",
                    })}
                  >
                    <IconButton onClick={handleSaveOfficialReport}>
                      <SaveIcon style={{ color: "#2540E4" }} />
                    </IconButton>
                  </Tooltip>
                )}
              </Grid>
            )}
            <div style={{ flexFlow: 1 }}></div>
            {!isDownloading && (
              <Grid>
                <Tooltip
                  title={intl.formatMessage({
                    id: "conference.minize",
                    defaultMessage: "Minimize",
                  })}
                >
                  <MinimizeIcon
                    onClick={(e) => {
                      if (me?.id.length > 8 && me?.id === room?.creator?.id)
                        handleSaveOfficialReport();
                      e.stopPropagation();
                      dispatch(setOfficialReportOpen(false));
                    }}
                    style={{ cursor: "pointer", marginBottom: 5 }}
                  />
                </Tooltip>
                <Tooltip
                  title={intl.formatMessage({
                    id: "conference.close",
                    defaultMessage: "Close",
                  })}
                >
                  <CloseIcon
                    onClick={(e) => {
                      if (me?.id.length > 8 && me?.id === room?.creator?.id)
                        handleSaveOfficialReport();
                      e.stopPropagation();
                      dispatch(setOfficialReportOpenGlobal(false));
                    }}
                    style={{
                      cursor: "pointer",
                      marginTop: 10,
                      width: 20,
                      height: 20,
                    }}
                  />
                </Tooltip>
              </Grid>
            )}
          </Grid>
          <Grid container spacing={0}>
            {me?.id === room?.creator?.id && isDownload === false && (
              <Tooltip
                title={intl.formatMessage({
                  id: "conference.downloadReport",
                  defaultMessage: "Download",
                })}
              >
                <IconButton onClick={onDownloadButtonClick}>
                  <GuardianDownloadIcon style={{ color: "#2540E4" }} />
                </IconButton>
              </Tooltip>
            )}
            <Grid item xs={12}>
              <Typography className={classes.mainTitle}>
                <FormattedMessage
                  id="conference.meetingReport"
                  defaultMessage="Meeting Report"
                />
              </Typography>
            </Grid>
            <Grid className={classes.sideTitle} item xs={2}>
              <Typography>
                <FormattedMessage
                  id="conference.dateTime"
                  defaultMessage="Date Time"
                />
              </Typography>
            </Grid>
            <Grid item xs={10}>
              <TextField
                className={classes.textField}
                value={new Date(
                  room.startTime ? room.startTime : room.startDate
                ).toLocaleString()}
                InputProps={{
                  readOnly: true,
                  disableUnderline: true,
                }}
              />
            </Grid>
            <Grid className={classes.sideTitle} item xs={2}>
              <Typography>
                <FormattedMessage
                  id="conference.subject"
                  defaultMessage="Subject"
                />
              </Typography>
            </Grid>
            <Grid item xs={10}>
              <TextField
                className={classes.textField}
                InputProps={{
                  readOnly:
                    me?.id !== selectedMeeting?.creator?.id || edit === false,
                  disableUnderline: true,
                }}
                value={subject}
                onChange={(event) => {
                  setSubject(event.target.value);
                }}
              />
            </Grid>
            <Grid className={classes.sideTitle} item xs={2}>
              <Typography>
                <FormattedMessage
                  id="conference.topics"
                  defaultMessage="Topics"
                />
              </Typography>
            </Grid>
            <Grid style={{ border: "1px solid " }} item xs={10}>
              <div style={{ flexGrow: 1 }}></div>
            </Grid>
            <Grid className={classes.sideTitle} item xs={2}>
              <Typography>{1}</Typography>
            </Grid>
            <Grid item xs={10}>
              <TextField
                className={classes.textField}
                InputProps={{
                  readOnly:
                    me?.id !== selectedMeeting?.creator?.id || edit === false,
                  disableUnderline: true,
                }}
                multiline
                value={topics[0] ? topics[0] : ""}
                onChange={(event) => {
                  topics[0] = event.target.value;
                  setTopics([...topics]);
                }}
              />
            </Grid>
            <Grid className={classes.sideTitle} item xs={2}>
              <Typography>{2}</Typography>
            </Grid>
            <Grid item xs={10}>
              <TextField
                className={classes.textField}
                InputProps={{
                  readOnly:
                    me?.id !== selectedMeeting?.creator?.id || edit === false,
                  disableUnderline: true,
                }}
                multiline
                value={topics[1] ? topics[1] : ""}
                onChange={(event) => {
                  topics[1] = event.target.value;
                  setTopics([...topics]);
                }}
              />
            </Grid>
            <Grid className={classes.sideTitle} item xs={2}>
              <Typography>{3}</Typography>
            </Grid>
            <Grid item xs={10}>
              <TextField
                className={classes.textField}
                InputProps={{
                  readOnly:
                    me?.id !== selectedMeeting?.creator?.id || edit === false,
                  disableUnderline: true,
                }}
                multiline
                value={topics[2] ? topics[2] : ""}
                onChange={(event) => {
                  topics[2] = event.target.value;
                  setTopics([...topics]);
                }}
              />
            </Grid>
            {topics.length > 0 &&
              topics.map((topic, index) => {
                if (index !== 0 && index !== 1 && index !== 2)
                  return (
                    <div style={{ width: "100%", display: "flex" }}>
                      <Grid className={classes.sideTitle} item xs={2}>
                        <Typography>{index + 1}</Typography>
                      </Grid>
                      <Grid item xs={10}>
                        <TextField
                          className={classes.textField}
                          InputProps={{
                            readOnly:
                              me?.id !== selectedMeeting?.creator?.id ||
                              edit === false,
                            disableUnderline: true,
                          }}
                          multiline
                          value={topic}
                          onChange={(event) => {
                            topics[index] = event.target.value;
                            setTopics([...topics]);
                          }}
                        />
                      </Grid>
                    </div>
                  );
              })}
            {edit === true && (
              <div style={{ width: "100%", display: "flex" }}>
                <Grid className={classes.sideTitle} item xs={2}>
                  <div style={{ flexGrow: 1 }}></div>
                </Grid>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "1px solid",
                  }}
                  item
                  xs={10}
                >
                  <Typography>
                    <FormattedMessage
                      id="conference.addNewTopic"
                      defaultMessage="Add New Topic"
                    />
                  </Typography>
                  <IconButton
                    className={classes.button}
                    onClick={handleAddTopic}
                  >
                    <AddIcon />
                  </IconButton>
                </Grid>
              </div>
            )}
            <Grid className={classes.sideTitle} item xs={2}>
              <Typography>
                <FormattedMessage id="conference.toDo" defaultMessage="To Do" />
              </Typography>
            </Grid>
            <Grid style={{ border: "1px solid" }} item xs={6}>
              <div style={{ flexGrow: 1 }}></div>
            </Grid>
            <Grid style={{ border: "1px solid" }} item xs={2}>
              <Typography>
                <FormattedMessage
                  id="conference.owner"
                  defaultMessage="Responsible Side/Person"
                />
              </Typography>
            </Grid>
            <Grid style={{ border: "1px solid" }} item xs={2}>
              <Typography>
                <FormattedMessage
                  id="conference.endDate"
                  defaultMessage="Completion Date"
                />
              </Typography>
            </Grid>
            <Grid className={classes.sideTitle} item xs={2}>
              <Typography>{1}</Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                className={classes.textField}
                InputProps={{
                  readOnly:
                    me?.id !== selectedMeeting?.creator?.id || edit === false,
                  disableUnderline: true,
                }}
                multiline
                value={todos[0] ? todos[0].todo : ""}
                onChange={(event) => {
                  todos[0] = {
                    todo: event.target.value,
                    owner: todos[0]?.owner ? todos[0]?.owner : "",
                    endDate: todos[0]?.endDate ? todos[0]?.endDate : "",
                  };
                  setTodos([...todos]);
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                className={classes.textField}
                InputProps={{
                  readOnly:
                    me?.id !== selectedMeeting?.creator?.id || edit === false,
                  disableUnderline: true,
                }}
                multiline
                value={todos[0] ? todos[0].owner : ""}
                onChange={(event) => {
                  todos[0] = {
                    todo: todos[0]?.todo ? todos[0]?.todo : "",
                    owner: event.target.value,
                    endDate: todos[0]?.endDate ? todos[0]?.endDate : "",
                  };
                  setTodos([...todos]);
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                className={classes.textField}
                InputProps={{
                  readOnly:
                    me?.id !== selectedMeeting?.creator?.id || edit === false,
                  disableUnderline: true,
                }}
                multiline
                value={todos[0] ? todos[0].endDate : ""}
                onChange={(event) => {
                  todos[0] = {
                    todo: todos[0]?.todo ? todos[0]?.todo : "",
                    owner: todos[0]?.owner ? todos[0]?.owner : "",
                    endDate: event.target.value,
                  };
                  setTodos([...todos]);
                }}
              />
            </Grid>
            <Grid className={classes.sideTitle} item xs={2}>
              <Typography>{2}</Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                className={classes.textField}
                InputProps={{
                  readOnly:
                    me?.id !== selectedMeeting?.creator?.id || edit === false,
                  disableUnderline: true,
                }}
                multiline
                value={todos[1] ? todos[1].todo : ""}
                onChange={(event) => {
                  todos[1] = {
                    todo: event.target.value,
                    owner: todos[1]?.owner ? todos[1]?.owner : "",
                    endDate: todos[1]?.endDate ? todos[1]?.endDate : "",
                  };
                  setTodos([...todos]);
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                className={classes.textField}
                InputProps={{
                  readOnly:
                    me?.id !== selectedMeeting?.creator?.id || edit === false,
                  disableUnderline: true,
                }}
                multiline
                value={todos[1] ? todos[1].owner : ""}
                onChange={(event) => {
                  todos[1] = {
                    todo: todos[1]?.todo ? todos[1]?.todo : "",
                    owner: event.target.value,
                    endDate: todos[1]?.endDate ? todos[1]?.endDate : "",
                  };
                  setTodos([...todos]);
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                className={classes.textField}
                InputProps={{
                  readOnly:
                    me?.id !== selectedMeeting?.creator?.id || edit === false,
                  disableUnderline: true,
                }}
                multiline
                value={todos[1] ? todos[1].endDate : ""}
                onChange={(event) => {
                  todos[1] = {
                    todo: todos[1]?.todo ? todos[1]?.todo : "",
                    owner: todos[1]?.owner ? todos[1]?.owner : "",
                    endDate: event.target.value,
                  };
                  setTodos([...todos]);
                }}
              />
            </Grid>
            <Grid className={classes.sideTitle} item xs={2}>
              <Typography>{3}</Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                className={classes.textField}
                InputProps={{
                  readOnly:
                    me?.id !== selectedMeeting?.creator?.id || edit === false,
                  disableUnderline: true,
                }}
                multiline
                value={todos[2] ? todos[2].todo : ""}
                onChange={(event) => {
                  todos[2] = {
                    todo: event.target.value,
                    owner: todos[2]?.owner ? todos[2]?.owner : "",
                    endDate: todos[2]?.endDate ? todos[2]?.endDate : "",
                  };
                  setTodos([...todos]);
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                className={classes.textField}
                InputProps={{
                  readOnly:
                    me?.id !== selectedMeeting?.creator?.id || edit === false,
                  disableUnderline: true,
                }}
                multiline
                value={todos[2] ? todos[2].owner : ""}
                onChange={(event) => {
                  todos[2] = {
                    todo: todos[2]?.todo ? todos[2]?.todo : "",
                    owner: event.target.value,
                    endDate: todos[2]?.endDate ? todos[2]?.endDate : "",
                  };
                  setTodos([...todos]);
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                className={classes.textField}
                InputProps={{
                  readOnly:
                    me?.id !== selectedMeeting?.creator?.id || edit === false,
                  disableUnderline: true,
                }}
                multiline
                value={todos[2] ? todos[2].endDate : ""}
                onChange={(event) => {
                  todos[2] = {
                    todo: todos[2]?.todo ? todos[2]?.todo : "",
                    owner: todos[2]?.owner ? todos[2]?.owner : "",
                    endDate: event.target.value,
                  };
                  setTodos([...todos]);
                }}
              />
            </Grid>
            {todos.length > 0 &&
              todos.map((todo, index) => {
                if (index !== 0 && index !== 1 && index !== 2)
                  return (
                    <div style={{ width: "100%", display: "flex" }}>
                      <Grid className={classes.sideTitle} item xs={2}>
                        <Typography>{index + 1}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          className={classes.textField}
                          InputProps={{
                            readOnly:
                              me?.id !== selectedMeeting?.creator?.id ||
                              edit === false,
                            disableUnderline: true,
                          }}
                          multiline
                          value={todo.todo}
                          onChange={(event) => {
                            todos[index].todo = event.target.value;
                            setTodos([...todos]);
                          }}
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <TextField
                          className={classes.textField}
                          InputProps={{
                            readOnly:
                              me?.id !== selectedMeeting?.creator?.id ||
                              edit === false,
                            disableUnderline: true,
                          }}
                          multiline
                          value={todo.owner}
                          onChange={(event) => {
                            todos[index].owner = event.target.value;
                            setTodos([...todos]);
                          }}
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <TextField
                          className={classes.textField}
                          InputProps={{
                            readOnly:
                              me?.id !== selectedMeeting?.creator?.id ||
                              edit === false,
                            disableUnderline: true,
                          }}
                          multiline
                          value={todo.endDate}
                          onChange={(event) => {
                            todos[index].endDate = event.target.value;
                            setTodos([...todos]);
                          }}
                        />
                      </Grid>
                    </div>
                  );
              })}
            {edit === true && (
              <div style={{ width: "100%", display: "flex" }}>
                <Grid className={classes.sideTitle} item xs={2}>
                  <div style={{ flexGrow: 1 }}></div>
                </Grid>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "1px solid",
                  }}
                  item
                  xs={10}
                >
                  <Typography>
                    <FormattedMessage
                      id="conference.andToDo"
                      defaultMessage="Add New To Do"
                    />
                  </Typography>
                  <IconButton
                    className={classes.button}
                    onClick={handleAddTodo}
                  >
                    <AddIcon />
                  </IconButton>
                </Grid>
              </div>
            )}
            <Grid className={classes.sideTitle} item xs={2}>
              <Typography>
                <FormattedMessage
                  id="conference.desicions"
                  defaultMessage="Desicions"
                />
              </Typography>
            </Grid>
            <Grid style={{ border: "1px solid" }} item xs={10}>
              <div style={{ flexGrow: 1 }}></div>
            </Grid>
            <Grid className={classes.sideTitle} item xs={2}>
              <Typography>{1}</Typography>
            </Grid>
            <Grid item xs={10}>
              <TextField
                className={classes.textField}
                InputProps={{
                  readOnly:
                    me?.id !== selectedMeeting?.creator?.id || edit === false,
                  disableUnderline: true,
                }}
                multiline
                value={desicions[0] ? desicions[0] : ""}
                onChange={(event) => {
                  desicions[0] = event.target.value;
                  setDesicions([...desicions]);
                }}
              />
            </Grid>
            <Grid className={classes.sideTitle} item xs={2}>
              <Typography>{2}</Typography>
            </Grid>
            <Grid item xs={10}>
              <TextField
                className={classes.textField}
                InputProps={{
                  readOnly:
                    me?.id !== selectedMeeting?.creator?.id || edit === false,
                  disableUnderline: true,
                }}
                multiline
                value={desicions[1] ? desicions[1] : ""}
                onChange={(event) => {
                  desicions[1] = event.target.value;
                  setDesicions([...desicions]);
                }}
              />
            </Grid>
            <Grid className={classes.sideTitle} item xs={2}>
              <Typography>{3}</Typography>
            </Grid>
            <Grid item xs={10}>
              <TextField
                className={classes.textField}
                InputProps={{
                  readOnly:
                    me?.id !== selectedMeeting?.creator?.id || edit === false,
                  disableUnderline: true,
                }}
                multiline
                value={desicions[2] ? desicions[2] : ""}
                onChange={(event) => {
                  desicions[2] = event.target.value;
                  setDesicions([...desicions]);
                }}
              />
            </Grid>
            {desicions.length > 0 &&
              desicions.map((desicion, index) => {
                if (index !== 0 && index !== 1 && index !== 2)
                  return (
                    <div style={{ width: "100%", display: "flex" }}>
                      <Grid className={classes.sideTitle} item xs={2}>
                        <Typography>{index + 1}</Typography>
                      </Grid>
                      <Grid item xs={10}>
                        <TextField
                          className={classes.textField}
                          InputProps={{
                            readOnly:
                              me?.id !== selectedMeeting?.creator?.id ||
                              edit === false,
                            disableUnderline: true,
                          }}
                          multiline
                          value={desicion}
                          onChange={(event) => {
                            desicions[index] = event.target.value;
                            setDesicions([...desicions]);
                          }}
                        />
                      </Grid>
                    </div>
                  );
              })}
            {edit === true && (
              <div style={{ width: "100%", display: "flex" }}>
                <Grid className={classes.sideTitle} item xs={2}>
                  <div style={{ flexGrow: 1 }}></div>
                </Grid>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "1px solid",
                  }}
                  item
                  xs={10}
                >
                  <Typography>
                    <FormattedMessage
                      id="conference.addDesicion"
                      defaultMessage="Add New Desicion"
                    />
                  </Typography>
                  <IconButton
                    className={classes.button}
                    onClick={handleAddDesicion}
                  >
                    <AddIcon />
                  </IconButton>
                </Grid>
              </div>
            )}
            <Grid className={classes.sideTitle} item xs={2}>
              <Typography>
                <FormattedMessage
                  id="conference.participants"
                  defaultMessage="Participants"
                />
              </Typography>
            </Grid>
            <Grid style={{ border: "1px solid" }} item xs={2}>
              <Typography>
                <FormattedMessage id="conference.side" defaultMessage="Side" />
              </Typography>
            </Grid>
            <Grid style={{ border: "1px solid" }} item xs={2}>
              <Typography>
                <FormattedMessage
                  id="conference.title"
                  defaultMessage="Title"
                />
              </Typography>
            </Grid>
            <Grid style={{ border: "1px solid" }} item xs={2}>
              <Typography>
                <FormattedMessage id="conference.name" defaultMessage="Name" />
              </Typography>
            </Grid>
            <Grid style={{ border: "1px solid" }} item xs={2}>
              <Typography>
                <FormattedMessage
                  id="conference.email"
                  defaultMessage="Email"
                />
              </Typography>
            </Grid>
            <Grid style={{ border: "1px solid" }} item xs={2}>
              <Typography>
                <FormattedMessage
                  id="conference.phone"
                  defaultMessage="Phone"
                />
              </Typography>
            </Grid>
            {participants?.map((u, index) => (
              <div style={{ display: "flex", width: "inherit" }}>
                <Grid className={classes.sideTitle} item xs={2}>
                  <div style={{ flexGrow: 1 }}></div>
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    className={classes.textField}
                    InputProps={{
                      readOnly:
                        me?.id !== selectedMeeting?.creator?.id ||
                        edit === false,
                      disableUnderline: true,
                    }}
                    value={
                      participants[index]?.side ? participants[index]?.side : ""
                    }
                    onChange={(event) => {
                      participants[index].side = event.target.value;
                      setParticipants([...participants]);
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    className={classes.textField}
                    InputProps={{
                      readOnly:
                        me?.id !== selectedMeeting?.creator?.id ||
                        edit === false,
                      disableUnderline: true,
                    }}
                    value={
                      participants[index]?.position
                        ? participants[index]?.position
                        : ""
                    }
                    onChange={(event) => {
                      participants[index].position = event.target.value;
                      setParticipants([...participants]);
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    className={classes.textField}
                    InputProps={{
                      readOnly:
                        me?.id !== selectedMeeting?.creator?.id ||
                        edit === false,
                      disableUnderline: true,
                    }}
                    value={
                      participants[index]?.displayName
                        ? participants[index]?.displayName
                        : ""
                    }
                    onChange={(event) => {
                      participants[index].displayName = event.target.value;
                      setParticipants([...participants]);
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    className={classes.textField}
                    InputProps={{
                      readOnly:
                        me?.id !== selectedMeeting?.creator?.id ||
                        edit === false,
                      disableUnderline: true,
                    }}
                    value={
                      participants[index]?.email
                        ? participants[index]?.email
                        : ""
                    }
                    onChange={(event) => {
                      participants[index].email = event.target.value;
                      setParticipants([...participants]);
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    className={classes.textField}
                    InputProps={{
                      readOnly:
                        me?.id !== selectedMeeting?.creator?.id ||
                        edit === false,
                      disableUnderline: true,
                    }}
                    value={
                      participants[index]?.phoneNumber
                        ? participants[index]?.phoneNumber
                        : ""
                    }
                    onChange={(event) => {
                      participants[index].phoneNumber = event.target.value;
                      setParticipants([...participants]);
                    }}
                  />
                </Grid>
              </div>
            ))}
            {edit === true && (
              <div style={{ width: "100%", display: "flex" }}>
                <Grid className={classes.sideTitle} item xs={2}>
                  <div style={{ flexGrow: 1 }}></div>
                </Grid>
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "1px solid",
                  }}
                  item
                  xs={10}
                >
                  <Typography>
                    <FormattedMessage
                      id="conference.addParticipant"
                      defaultMessage="Add New Participant"
                    />
                  </Typography>
                  <IconButton
                    className={classes.button}
                    onClick={handleAddParticipants}
                  >
                    <AddIcon />
                  </IconButton>
                </Grid>
              </div>
            )}
          </Grid>
        </Box>
      )}
    </div>
  );
};

export default ConferenceOfficialReport;
